/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class OrderInvoiceItemViewModel {
    name: string;
    price: number | null;
    priceText: string;
    normalizedSort: number;
    priceCalculationSortOffset: number | null;
    initialSort: number;
    sort: number;
    sectionFragmentId: string | null;
    dormerMaterialId: string | null;
    dormerColorId: string | null;
    priceCalculationStrategyId: string | null;
    quantity: number;
    priceCalculationHideResult: boolean;
    dedupeString: string = "-";
    subItems: OrderInvoiceItemViewModel[] = [];
    groupOnIdenticalNameAndPriceOutcome: boolean;
}
